// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__SQAH-","checkboxCol":"Table_checkboxCol__1eAKr","emailCol":"Table_emailCol__Lrvbb","actionCol":"Table_actionCol__2dEm1"};